export const paymentMethods = {
  cash: 'Efectivo',
  card: 'Tarjeta de crédito o débito'
}